import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { Playbook, PlaybookStep } from "../model/Playbook";

export const useUpdatePlaybook = () => {
  const {
    data: updatedPlaybook,
    call,
    isLoading: isUpdating,
    isFailed: isUpdateFailed,
  } = useApiPrivateRequest<Playbook>((response) => new Playbook(response));

  const updatePlaybook = async (
    id: string,
    title?: string,
    description?: string,
    steps?: PlaybookStep[],
  ) => {
    const result = await call(`/playbooks/${id}`, "PUT", undefined, {
      title,
      description,
      steps,
    });
    return result;
  };

  return {
    updatedPlaybook,
    updatePlaybook,
    isUpdating,
    isUpdateFailed,
  };
};
